/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function toggleProductVideoPlayback(slide) {
    const player = slide.querySelector('video');
    const youtube = slide.querySelector('[data-host="youtube"]');
    const vimeo = slide.querySelector('[data-host="vimeo"]');
    const isPaused = slide.classList.contains('paused');

    if (player) {
      if (isPaused) {
        player.play();
      } else {
        player.pause();
      }
    } else if (youtube) {
      const action = isPaused ? 'playVideo' : 'pauseVideo';
      youtube.contentWindow.postMessage(`{"event":"command","func":"${action}","args":""}`, '*');
    } else if (vimeo) {
      const action = isPaused ? 'play' : 'pause';
      vimeo.contentWindow.postMessage(`{"method":"${action}"}`, '*');
    }

    slide.classList.toggle('paused');
  }

  function initProductVideoControls(container = document) {
    container.querySelectorAll('.product__slide[data-video] .slideshow__pause-control').forEach((control) => {
      if (control.dataset.productVideoBound === 'true') return;

      control.dataset.productVideoBound = 'true';
      control.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const slide = control.closest('.product__slide[data-video]');
        if (!slide) return;

        const deferredMedia = slide.querySelector('deferred-media');
        if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
          slide.querySelector('[data-deferred-media-button]')?.click();
        }

        toggleProductVideoPlayback(slide);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductVideoControls());

  document.addEventListener('shopify:section:load', (event) => {
    initProductVideoControls(event.target);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
